export const editSocialSecurityQuiz = (key, value) => ({
  type: 'EDIT_SOCIAL_SECURITY_QUIZ',
  key,
  value,
});
